export const getDashboardDataStart = () => ({
	type: "GET_DASHBOARD_DATA_START",
});

export const getDashboardDataSuccess = (dashboardData) => ({
	type: "GET_DASHBOARD_DATA_SUCCESS",
	payload: dashboardData
});

export const getDashboardDataFailure = () => ({
	type: "GET_DASHBOARD_DATA_FAILURE",
});